<template>
  <div class="pageMaintenance">
    <div class="title">{{ title }}</div>
    <div class="subtitle">{{ subTitle }}</div>
  </div>
</template>
<script>
export default {
  // name: 'setting-maintenance',
  data () {
    return {
      title: 'Maintenance in progress...',
      subTitle: ''
    }
  },
  methods: {},
  computed: {
    statusServer () {
      return this.$store.getters['statusServer']
    }
  },
  watch: {
    statusServer (val) {
      if (val.length > 0) {
        this.subTitle = val[1].messages
        if (val[0].messages == 'online') {
          this.$router.push('/login')
        }
      }
    }
  },
  created () {
    this.$store.dispatch('watchServer')
  },
  components: {}
}
</script>
<style lang="scss" scoped>
.pageMaintenance {
  height: calc(100vh - 5px);
  background: #fff;
  text-align: center;
  padding: 100px;
  color: #858383;
  .title {
    font-size: 45px;
  }
  .subtitle {
    margin-top: 35px;
    font-size: 24px;
  }
}
</style>
